import PageHeader from "../components/PageHeader";
import QualityAssurance from "../components/QualityAssurance";
import Certifications from "../components/Certifications";
import FinalCTA from "../components/FinalCTA";
import { useLang } from "../i18n/LanguageContext";

export default function QualityPage() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        overline={t("pages.qualityOverline")}
        title={<>{t("pages.qualityTitlePre")} <span className="italic text-[#1E3A5F]">{t("pages.qualityTitleItalic")}</span>{t("pages.qualityTitlePost")}</>}
        subtitle={t("pages.qualitySubtitle")}
      />
      <QualityAssurance />
      <Certifications />
      <FinalCTA />
    </>
  );
}
